<template>
  <div class="top_title">
    <div class="top_name title_size flex relative">
      <div class="flex_1" v-html="name"></div>
          <div class="btn-main flex_1 w-100 m-0 d-flex align-items-center" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false" >
            {{ buttonName }}<i class="ri-arrow-down-s-line"> </i>
          </div>

          <div
            class="dropdown-menu dropdown-menu-start dropdown_box"
            aria-labelledby="dropdownMenuClickableInside"
            style="
              width: 336px;
              color: #fff;
              z-index: 1;
              padding: 10px 0px;
              border-radius: 1.25rem;
              background:#213247;
              box-shadow: 0px 1.25rem 3.8125rem 0px rgba(16, 20, 28, 0.6);
              border-top: 0.0625rem solid #b6b7bc3f;
              border-left: 0.0625rem solid #b6b7bc3f;
              border-right: 0.0625rem solid #b6b7bc3f;
              height: 350px;
              transform: translate(-15px, 43px) !important;
              box-shadow: 0 1px 2px rgba(56,65,74,0.15);
            "
          >
            <div class="h-100 w-100">
              <div>
                <p class="mb-0" style="font-size: 16px; margin-left: 20px">
                  {{ $t("overview_static.device_page.add_more_data") }}
                </p>
                <img :src="imageLists.divider" alt="" />
              </div>
              <div
                id="cockpitTree"
                data-simplebar
                data-simplebar-auto-hide="false"
                style="
                  overflow: auto;
                  width: 100%;
                  height: calc(100% - 60px);
                  max-height: calc(100% - 60px);
                "
              >
              <el-tree
              ref="tree"
                :data="dataList"
                show-checkbox
                node-key="id"
                :default-checked-keys="defaultCheckedKeys"
                :props="defaultProps"
                default-expand-all
                @check="checkTree"
                v-model:checked-keys="checkedKeys"
              />
              </div>
            </div>
          </div>
    </div>
    <!-- 生产状态 -->
    <div class="output_status">
      <img :src="imageLists[`divider${lineType}`]" alt="" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { IS_DEMO_PAPER_MAKING_CUSTOMER_ID } from "@/config/common.js";
export default {
  name: "Top",
  data() {
    return {
      option_show: false,
      imageLists: {
        divider: require("@/assets/icon-font/icon-divider.svg"),
        dropdown: require("@/assets/icon-font/icon-dropdown.svg"),
        divider2: require("@/assets/icon-font/icon-divider2.svg"),
        divider1: require("@/assets/icon-font/icon-divider1.svg"),
      },
      defaultProps:{
        children: 'children',
        label: 'name',
      },
    };
  },
  props: {
    equip_data:{
      type: Object,
      default: ()=>{
        return {};
      }
    },
    name: {
      type: String,
      default: ""
    },
    buttonName: {
      type: String,
      default: ""
    },
    lineType: {
      type: String,
      default: ""
    },
    defaultCheckedKeys:{
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  emits:["handleCurrentSelect"],
  mounted(){
    
  },
  computed: {
    // 设备测点层级获取
    dataList(){
      var list = [];
      const data = _.cloneDeep(this.$store.state.equipManagement.equipData) 
      if(data.children){
        data.children.forEach(item=>{
          if (item.attributes&&item.attributes.measurements.length) {
            let filter_list = item.attributes.measurements.filter(measu=>measu.is_show) //过滤掉无需展示的测点
            list.push({
              id:item.id,
              name:item.name,
              disabled:true,
              children:filter_list.map(measu=>{
                return {
                  ...measu,
                  id:this.isPaperMaking?`${item.root_sn}-${measu.id}`:measu.id,
                  disabled:this.isPaperMaking?(this.defaultCheckedKeys.includes(`${item.root_sn}-${measu.id}`)?false:true):false,
                }
              }),
            })
          }
        })
      }
      // list.reverse()//反转
      return  list;
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.equipData.customer_id == IS_DEMO_PAPER_MAKING_CUSTOMER_ID//造纸厂展示内容
    },
    //可选中复选框的个数
    checkedNum() {
      return this.isPaperMaking?3:2;
    },
  },
  watch: {
    option_show(val) {
      let dom = document.getElementsByClassName("select_icon");
      if (val) {
        dom[0].classList.add("rotate");
      } else {
        dom[0].classList.remove("rotate");
      }
    }
  },
  methods: {
    /* 勾选状态 */
    checkTree(checkedNodes,checkedKeysArry){
      const {checkedKeys} = checkedKeysArry
      let checkeds = []

      if (checkedKeys.length > this.checkedNum) {
        // 如果选中的复选框超过两个，则保留前两个
        checkeds = checkedKeys.filter(item=>item != checkedNodes.id);
        // 更新树的选中状态
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(checkeds);
        });
        return;
      } else {
        checkeds= checkedKeys;
      }
      this.$emit("handleCurrentSelect",checkeds)
      
    },
    toggleChecked() {
      this.option_show = !this.option_show;
    },
    recursionArr(data) {
      let result = [];
      let num = 0;
      let queue = data;
      while (queue.length > 0) {
        num += 1;
        [...queue].forEach((child, i) => {
          queue.shift();
          child.index = i;
          child.num = num;
          child.iconType = true;
          child["subId"] = "a" + child.id;
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }

      return result.filter((item) => {
        return item.num == 1;
      });
    },
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../assets/scss/common.scss");
.top_title {
  width: 100%;
  line-height: 20px;
}
.top_name {
  display: flex;
  align-items: center;
}

.btn-main {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  .select_icon {
    width: 12px;
    margin-left: 10px;
    background-size: cover;
    background-repeat: no-repeat;
    &.rotate {
      transform: rotate(180deg);
    }
  }
}
.select_option {
  font-size: 14px;
  background-color: #000;
  border: 1px solid #2c2c2c;
  border-radius: 10px;
  box-sizing: border-box;
  z-index: 8;
  position: absolute;
  top: 100%;
  right: 0;
  .option {
    padding: 10px;
    &:nth-of-type(1) {
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
    }
    &:hover {
      cursor: pointer;
      background-color: #062323;
    }
  }
  .option_name {
    margin-left: 10px;
  }
}

.output_status {
  width: 100%;
  line-height: 10px;
  background-size: cover;
  background-repeat: no-repeat;
}
// tree 结构背景颜色
 :deep(.el-tree){
  background-color: rgb(33, 50, 71) !important;
}
</style>
